// extracted by mini-css-extract-plugin
module.exports = {"root":"SendButton_root__2na_j","input":"SendButton_input__34gCu","button":"SendButton_button__2smrb"};